export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "reduceCanvasTo256Color.worker.e43bc8bb26f7eb5c2b56.worker.js");
}
